// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import AmazonCircleFilledSvg from "@fishx/icons-svg/es/asn/AmazonCircleFilled";
import FishxIcon from '../components/FishxIcon';

var AmazonCircleFilled = function AmazonCircleFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: AmazonCircleFilledSvg
  }));
};

AmazonCircleFilled.displayName = 'AmazonCircleFilled';
export default React.forwardRef(AmazonCircleFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/AmazonCircleFilled.js
// module id = 1982
// module chunks = 0